import { EventEmitter } from 'events';
import assign from 'object-assign';
import Immutable from 'immutable';
import _ from 'underscore';

import ApplicationDispatcher from '../../../dispatcher/ApplicationDispatcher.js';
import WorkspaceConstants from '../../flux/WorkspaceConstants.js';

/*
    uploads: {
        <eventID || uid>: [
            {
                uploadJson: {...},
                response: {
                    total: 0,
                    position: 0,
                    percentComplete: 0
                }
            }
        ]
    }

    Event Upload:
        uploadJson = {
            assetID : '',
            operation : upload,
            clientID : CredentialManager.getClient(),
            eventID : this.state.eventId,
            name : this.state.previewName
        };

    Miscellaneous:
        uploadJson = {
            operation : misc,
            clientID : CredentialManager.getClient(),
            name : this.state.previewName
        };
 */
var eventUploads = {}
var globalUploads = {}

var uploadModal = false;
var assignModal = false;

var targeted = null;

var UploadStore = assign({}, EventEmitter.prototype, {

    getUploadModalState: function () {
        return uploadModal;
    },

    getTargetedState: function () {
        return targeted;
    },

    getEventUploads: function () {
        return eventUploads;
    },

    getGlobalUploads: function () {
        return globalUploads;
    },

    emitChange: function () {
        this.emit('change');
    },

    addChangeListener: function (callback) {
        this.on('change', callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener('change', callback);
    }
});


function getId (uploadJson) {
    return uploadJson.uid;
}

UploadStore.dispatchToken = ApplicationDispatcher.register(function (payload) {

    var action = payload.action, data = payload.action.data;
    switch (action.actionType) {
        case WorkspaceConstants.UPLOAD_MODAL_TOGGLE:
            if (data) targeted = data;
            uploadModal = !uploadModal;
            UploadStore.emitChange();
            break;


        /*
            data.uploadJson.operation == 'upload':
            eventUploads: Map<K, V> {
                #eventID: {
                    #uid: {
                        uploadJson: {...},
                        response: {...}
                    }, ...
                }
            }
         */
        case WorkspaceConstants.UPLOAD_ADD:
            // console.log('UPLOAD_ADD');

            var uid = data.uid;
            if (data.uploadJson.operation == 'upload') {
                var eventID = data.uploadJson.eventID;
                if (!eventUploads.eventID) { 
                    eventUploads.eventID = eventID
                }
                eventUploads.eventID.uid = data
            } else if (data.uploadJson.operation == 'misc') {
                globalUploads.uid = data
            }
            UploadStore.emitChange();
            break;

        case WorkspaceConstants.UPLOAD_PROGRESS:
            if (data.uploadJson.operation == 'upload') {
                /*
                    Only update in 5% increments, otherwise it could re-render
                    the Assets/Upload Containers too frequently.
                 */
                if (data.response.percentComplete % 5 === 0) {
                    // console.log('UPLOAD_PROGRESS');
                    var eventID = data.uploadJson.eventID;
                    var uid = data.uid;
                    eventUploads = eventUploads.mergeDeepIn([eventID, uid], data);
                }
            } else if (data.uploadJson.operation == 'misc') {
                var uid = data.uid;
                globalUploads = globalUploads.mergeDeepIn([uid], data);
            }

            UploadStore.emitChange();
            break;

        case WorkspaceConstants.UPLOAD_FINISHED:
            // console.log('UPLOAD_FINISHED');

            if (data.uploadJson.operation == 'upload') {
                var eventID = data.uploadJson.eventID;
                eventUploads = eventUploads.slice(eventID, 1);
            } else if (data.uploadJson.operation == 'misc') {
                var uid = data.uid;
                globalUploads = globalUploads.delete(uid);
            }
            UploadStore.emitChange();
            break;


    }
})

export default UploadStore;
